<template>
  <div>
    <div class="page-header page-header-small">
      <parallax class="page-header-image" :style="backgroundTopo"></parallax>
      <div class="content-center">
        <div class="content-center brand">
          <h1 class="h1-seo">Criar demanda</h1>
        </div>
      </div>
    </div>

    <div class="section section-contact-us text-center">
      <div class="container">
        <form @submit.prevent="onSubmit" class="col-md-8 ml-auto mr-auto text-center">
          <p class="description">Informe abaixo os dados da demanda.</p>
          <b-card>
            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <b-form-input
                    :state="validateState('titulo')"
                    id="titulo"
                    name="titulo"
                    placeholder="Titulo"
                    v-model="titulo"
                    v-validate="'required'"
                    aria-describedby="titulo-feedback"
                    maxlength="50"
                  ></b-form-input>

                  <b-form-invalid-feedback id="titulo-feedback"
                    >É necessário informar o campo 'Título'.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6" v-if="tipoDemandaBase == undefined || tipoDemandaBase == 'DM;FD'">
                <b-form-group>
                  <b-form-select class="form-control" v-model="tipoDemanda" id="tipoDemanda" name="tipoDemanda">
                    <option :value="null">Selecione o Grupo do objetivo</option>
                    <option value="DM">Demanda</option>
                    <option value="FX">Faixa domínio</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="tipoDemanda-feedback">{{ labelInformarTipo }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group>
                  <b-form-select
                    :state="validateState('objetivo')"
                    class="form-control"
                    id="objetivo"
                    name="objetivo"
                    v-model="objetivo"
                    v-validate="'required'"
                    aria-describedby="objetivo-feedback"
                  >
                    <option :value="null">{{ labelSelecionarObjetivo }}</option>
                    <option
                      v-for="(objetivo, idx) in getObjetivosByGrupo(tipoDemanda)"
                      :key="idx"
                      :value="objetivo.value.id"
                      >{{ objetivo.text }}</option
                    >
                  </b-form-select>

                  <b-form-invalid-feedback id="objetivo-feedback">{{ labelInformarObjetivo }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <b-form-select
                    :options="getTipos()"
                    :state="validateState('tipo')"
                    class="form-control"
                    id="tipo"
                    name="tipo"
                    v-model="tipo"
                    v-validate="'required'"
                    aria-describedby="tipo-feedback"
                  ></b-form-select>

                  <b-form-invalid-feedback id="tipo-feedback">Selecione o 'Tipo' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="tipoDemanda === 'FX'">
                <!-- Validacao: :state="validateState('area')" aria-describedby="area-feedback" -->
                <b-form-group>
                  <b-form-select
                    :options="areas"
                    class="form-control"
                    id="area"
                    name="area"
                    v-model="area"
                  ></b-form-select>

                  <b-form-invalid-feedback id="area-feedback">Selecione a 'Área' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-select
                    class="form-control"
                    id="cidade"
                    name="cidade"
                    v-model="cidade"
                    aria-describedby="cidade-feedback"
                    @change="handleSelectCidade"
                  >
                    <option :value="null">Selecione a Cidade</option>
                    <optgroup
                      v-if="trecho == null"
                      v-for="(rdv, idxRdv) in getRodoviasByTrechos()"
                      :key="idxRdv"
                      :label="rdv"
                    >
                      <option v-for="(cidade, idx) in getCidadesByRodovia(rdv)" :key="idx" :value="cidade.value">{{
                        cidade.text
                      }}</option>
                    </optgroup>
                    <option
                      v-if="trecho != null"
                      v-for="(cidade, idx) in getCidades()"
                      :key="idx"
                      :value="cidade.value"
                      >{{ cidade.text }}</option
                    >
                  </b-form-select>

                  <b-form-invalid-feedback id="cidade-feedback">Informe a 'Cidade' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="8">
                <b-form-group>
                  <b-form-select
                    :state="validateState('trecho')"
                    class="form-control"
                    id="trecho"
                    name="trecho"
                    v-model="trecho"
                    v-validate="'required'"
                    aria-describedby="trecho-feedback"
                  >
                    <option :value="null">Selecione a Rodovia</option>
                    <optgroup v-for="(rodovia, idx) in getRodoviasByTrechos()" :key="idx" :label="rodovia">
                      <option
                        v-for="(trecho, idxTre) in getTrechosByRodovia(rodovia)"
                        :key="idxTre"
                        :value="trecho.id"
                        >{{ getTrechoInfo(trecho) }}</option
                      >
                    </optgroup>
                  </b-form-select>

                  <b-form-invalid-feedback id="trecho-feedback"
                    >Informe a 'Rodovia' da demanda.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <b-form-select
                    class="form-control"
                    id="sentido"
                    name="sentido"
                    v-model="sentido"
                    aria-describedby="sentido-feedback"
                  >
                    <option :value="null">Selecione o Sentido</option>
                    <option value="N">Norte</option>
                    <option value="S">Sul</option>
                    <option value="L">Leste</option>
                    <option value="O">Oeste</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="3">
                <b-form-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmInicial == null"
                    id="kmInicial"
                    name="kmInicial"
                    placeholder="KM Inicial"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmInicial"
                    @change="changeKmInicial"
                    aria-describedby="kmIni-feedback"
                  ></vue-numeric>

                  <b-form-invalid-feedback :state="errorKmInicial == null" id="kmIni-feedback">{{
                    errorKmInicial
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmFinal == null"
                    id="kmFinal"
                    name="kmFinal"
                    placeholder="KM Final"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmFinal"
                    @change="changeKmFinal"
                    aria-describedby="kmFim-feedback"
                  ></vue-numeric>

                  <b-form-invalid-feedback :state="errorKmFinal == null" id="kmFim-feedback">{{
                    errorKmFinal
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <!-- Validação: :state="validateState('local')" -->
                <b-form-group>
                  <b-form-select
                    :options="locais"
                    class="form-control"
                    id="local"
                    name="local"
                    v-model="local"
                    aria-describedby="local-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="tipoDemanda === 'FX'">
                <b-form-group>
                  <b-form-select
                    :options="alcas"
                    :state="validateState('alcas')"
                    class="form-control"
                    id="alca"
                    name="alca"
                    v-model="alca"
                    aria-describedby="alca-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="tipoDemanda === 'FX'">
                <b-form-group>
                  <b-form-select
                    :options="faixas"
                    :state="validateState('faixa')"
                    class="form-control"
                    id="faixa"
                    name="faixa"
                    v-model="faixa"
                    aria-describedby="faixa-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <b-form-textarea
                    class="form-control"
                    name="name"
                    rows="2"
                    cols="80"
                    placeholder="Observações..."
                    v-model="observacao"
                    maxlength="255"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Anexo de arquivos:"
                  label-cols-lg="10"
                  label-size="sm"
                  label-text-align="left"
                  class="text-left"
                ></b-form-group>
                <b-form-group>
                  <b-form-file
                    :multiple="true"
                    v-model="files"
                    placeholder="Selecione o(s) arquivo(s) para anexar"
                    drop-placeholder="Arraste o(s) arquivo(s) aqui"
                    @input="onUpload"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <badge type="default">{{ names[0] }}</badge>
                      <badge v-if="names.length > 1" type="default" class="ml-1"
                        >+ {{ names.length - 1 }} arquivos</badge
                      >
                    </template>
                  </b-form-file>

                  <b-list-group>
                    <b-list-group-item
                      v-for="(file, idx) in files"
                      :key="'file-' + idx"
                      class="flex-column align-items-start"
                    >
                      <div class="d-flex w-100 justify-content-between">
                        <div>{{ file.name }}</div>
                        <div>
                          <b-form-select class="form-control" v-model="tiposAnexo[idx]">
                            <option :value="null">Selecione</option>
                            <optgroup label="Projeto">
                              <option value="PF">Projeto Funcional</option>
                              <option value="PB">Projeto Básico</option>
                              <option value="PE">Projeto Executivo</option>
                            </optgroup>
                            <optgroup label="Orçamento">
                              <option value="OF">Orçamento Funcional</option>
                              <option value="OB">Orçamento Básico</option>
                              <option value="OE">Orçamento Executivo</option>
                            </optgroup>
                            <option value="FC">Ofício</option>
                            <option value="FT">Foto</option>
                            <option value="OU">Outros</option>
                          </b-form-select>
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col :cols="2"></b-col>
            <b-col cols="8">
              <div class="send-button">
                <b-button :disabled="veeErrors.any()" class="btn-round" type="submit" variant="primary" block size="lg"
                  >Enviar solicitação</b-button
                >
              </div>
            </b-col>
          </b-row>

          <b-modal id="confirm-modal" hide-footer>
            <template slot="modal-title"
              >Solicitação incluída</template
            >
            <div class="d-block text-center">
              Sua solicitação foi realizada com sucesso.
              <br />
              <span>N&deg; Protocolo: {{ protocolo }}</span>
            </div>
            <b-button class="mt-2" block @click="hideModal">Fechar</b-button>
          </b-modal>

          <b-modal id="error-modal" hide-footer>
            <template slot="modal-title"
              >Erro incluindo Solicitação</template
            >
            <div class="d-block text-center">
              Não foi possível registrar sua solicitação.
            </div>
            <b-button class="mt-2" block @click="hideModalError">Fechar</b-button>
          </b-modal>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueNumeric from 'vue-numeric';
import { Badge, Button, FormGroupInput } from '@/components';
import { mapState } from 'vuex';

import moment from 'moment';

import numeral from 'numeral';
import 'numeral/locales';

export default {
  name: 'novaDemanda',
  bodyClass: 'novaDemanda-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Badge.name]: Badge,
    VueNumeric
  },
  data() {
    return {
      backgroundTopo: "background-image: url('/img/solicitacao.jpg')",
      tipos: [{ value: null, text: 'Selecione o Tipo' }],
      areas: [{ value: null, text: 'Selecione a Área' }],
      objetivos: [{ value: null, text: this.labelSelecionarObjetivo }],
      locais: [{ value: null, text: 'Selecione o Local' }],
      alcas: [{ value: null, text: 'Nomenclatura da Alça' }],
      faixas: [{ value: null, text: 'Selecione a Faixa' }],
      cidades: [], // Array of cidades
      trechos: [], // Array of trechos
      titulo: '',
      tipo: null,
      area: null,
      tipoDemanda: this.$store.state.account.tipo,
      tipoDemandaBase: this.$store.state.account.tipo, // cache para avaliação visual
      objetivo: null,
      cidade: null,
      trecho: null,
      trechoCidade: null, // helper para filtrar trechos x cidade
      kmInicial: '',
      kmFinal: '',
      sentido: null,
      local: null,
      alca: null,
      faixa: 'FAIXA_1',
      observacao: '',
      files: [],
      protocolo: '',
      tiposAnexo: ([].tamanho = 12),
      labelSelecionarObjetivo: 'Selecione o Objetivo',
      labelInformarObjetivo: "Informe a 'Objetivo' da demanda.",
      labelSelecionarTipo: 'Selecione o Tipo',
      labelInformarTipo: "Informe o 'Tipo' da demanda",
      errorKmInicial: null,
      errorKmFinal: null
    };
  },
  computed: {
    ...mapState('empresa', ['empresas', 'empresaAtual'])
  },
  mounted() {
    if (window.config) {
      if (window.config.LABELS) {
        this.labelSelecionarObjetivo = window.config.LABELS.novaDemanda.selecionarObjetivo;
        this.labelSelecionarTipo = window.config.LABELS.novaDemanda.selecionarTipo;
        this.labelInformarObjetivo = window.config.LABELS.novaDemanda.informarObjetivo;
        this.labelInformarTipo = window.config.LABELS.novaDemanda.informarTipo;
      }

      if (window.config.SIGLA_ASSETS) {
        const siglaAssets = window.config.SIGLA_ASSETS;
        this.backgroundTopo = `background-image: url('/img/${siglaAssets}/solicitacao.jpg')`;
      }
    }

    numeral.locale('pt-br');

    if (this.tipoDemandaBase == 'DM;FD') {
      this.tipoDemanda = null;
    }

    this.fillData();
  },
  methods: {
    changeKmInicial() {
      const formatter = numeral(this.kmInicial);
      this.kmInicial = formatter.format('##[.]###');

      this.errorKmInicial = null;
    },
    changeKmFinal() {
      const formatter = numeral(this.kmFinal);
      this.kmFinal = formatter.format('##[.]###');

      this.errorKmFinal = null;
    },
    fillData() {
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      this.tipos = [{ value: null, text: this.labelSelecionarTipo }];
      this.areas = [{ value: null, text: 'Selecione a Área' }];
      this.objetivos = [{ value: null, text: 'Selecione o Objetivo' }];
      this.locais = [{ value: null, text: 'Selecione o Local' }];
      this.alcas = [{ value: null, text: 'Nomenclatura da Alça' }];
      this.faixas = [{ value: null, text: 'Selecione a Faixa' }];

      this.cidades = []; // Array of cidades
      this.trechos = []; // array of trechos

      // Fill Locais
      this.locais.push({ value: 'EIXO_TRONCAL', text: 'Eixo Troncal' });
      this.locais.push({ value: 'MARGINAL_DIREITA', text: 'Marginal Direita' });
      this.locais.push({ value: 'MARGINAL_ESQUERDA', text: 'Marginal Esquerda' });
      this.locais.push({ value: 'DISPOSITIVO', text: 'Dispositivo' });

      // Fill Faixas
      this.faixas.push({ value: 'FAIXA_1', text: '1' });
      this.faixas.push({ value: 'FAIXA_2', text: '2' });
      this.faixas.push({ value: 'FAIXA_3', text: '3' });
      this.faixas.push({ value: 'FAIXA_4', text: '4' });
      this.faixas.push({ value: 'FAIXA_5', text: '5' });
      this.faixas.push({ value: 'FAIXA_6', text: '6' });
      this.faixas.push({ value: 'ACOSTAMENTO_INTERNO', text: 'Acostamento Interno' });
      this.faixas.push({ value: 'ACOSTAMENTO_EXTERNO', text: 'Acostamento Externo' });

      // Fill Nomenclaturas : Ramos
      for (let i = 100; i <= 900; i += 100) {
        this.alcas.push({ value: 'RAMO_' + i, text: 'Ramo ' + i });
      }

      // Fill Nomenclaturas : Rotatórias
      for (let i = 100; i <= 900; i += 100) {
        this.alcas.push({ value: 'ROTATORIA_', text: 'Rotatória ' + i });
      }

      // REST GET para dados Back-End
      Vue.axios.get(`/demandas/${sigla}/dados`, options).then(response => {
        const rowData = response.data;

        // Áreas
        if (rowData.areas) {
          for (var area of rowData.areas) {
            this.areas.push({ value: area.id, text: area.descricao });
          }
        }

        // Tipos
        if (rowData.tipos) {
          for (var tipo of rowData.tipos) {
            this.tipos.push({ value: tipo, text: tipo.descricao });
          }
        }

        // Tipos
        if (rowData.objetivos) {
          for (var obj of rowData.objetivos) {
            this.objetivos.push({ value: obj, text: obj.descricao });
          }
        }

        // Trechos
        this.trechos = rowData.trechos;

        // Cidades
        this.cidades = rowData.cidades;
      });
    },
    getCidades() {
      const cidadesData = [];
      for (const cidade of this.cidades) {
        if (this.trecho != null && this.trecho !== undefined) {
          if (cidade.idTrecho != this.trecho) {
            continue;
          }
        }

        cidadesData.push({
          value: cidade,
          text: cidade.cidade.descricao + ' - [Km ' + cidade.kmInicial + ' ao Km ' + cidade.kmFinal + ']'
        });
      }

      cidadesData.sort((a, b) => {
        let cmp = a.value.kmInicial - b.value.kmInicial;
        if (cmp == 0) {
          cmp = ('' + a).localeCompare(b);
        }

        return cmp;
      });

      return cidadesData;
    },
    getCidadesByRodovia(rodovia) {
      const cidadesData = [];
      for (const cidade of this.cidades) {
        if (cidade.trecho.rodovia.descricao === rodovia) {
          cidadesData.push({
            value: cidade,
            text: cidade.cidade.descricao + ' - [Km ' + cidade.kmInicial + ' ao Km ' + cidade.kmFinal + ']'
          });
        }
      }

      cidadesData.sort((a, b) => {
        let cmp = a.value.kmInicial - b.value.kmInicial;
        if (cmp == 0) {
          cmp = ('' + a).localeCompare(b);
        }

        return cmp;
      });

      return cidadesData;
    },
    getGruposByObjetivos() {
      // Agrupa os Objetivos pelos Tipos (Demanda, Faixa Domínio)
      const data = [];

      const tipoDem = 'Demanda';
      const tipoFxa = 'Faixa Domínio';

      if (this.objetivos != null) {
        for (const objetivo of this.objetivos) {
          if (objetivo.value == null) continue;

          let tipoGrp = '';
          if (objetivo.value.grupo === 1) tipoGrp = tipoDem;
          else if (objetivo.value.grupo === 2) tipoGrp = tipoFxa;

          let found = false;
          for (var grpObj of data) {
            if (grpObj === tipoGrp) {
              found = true;
            }
          }

          if (!found) data.push(tipoGrp);
        }
      }
      return data;
    },
    getObjetivosByGrupo(tipoDemanda) {
      //const grupo = (tipoDemanda == undefined || tipoDemanda.includes('DM')) ? 1 : 2;
      if (tipoDemanda == undefined) return [];

      const grupo = tipoDemanda == 'DM' ? 1 : 2;

      const data = [];

      if (this.objetivos != null) {
        for (const objetivo of this.objetivos) {
          if (objetivo.value == null) continue;

          if (objetivo.value.grupo === grupo) {
            data.push(objetivo);
          }
        }
      }

      return data;
    },
    getRodoviasByTrechos() {
      const rodovias = [];
      for (const trecho of this.trechos) {
        let found = false;
        for (const rodovia of rodovias) {
          if (rodovia == trecho.rodovia.descricao) {
            found = true;
            break;
          }
        }

        if (!found) {
          rodovias.push(trecho.rodovia.descricao);
        }
      }

      return rodovias;
    },
    getTipos() {
      const data = [];
      data.push({ value: null, text: this.labelSelecionarTipo });

      for (const tipo of this.tipos) {
        if (tipo.value == null) continue;

        if (this.objetivo != undefined) {
          if (tipo.value.idObjetivo === this.objetivo) data.push(tipo);
        }
      }

      return data;
    },
    getTrechosByRodovia(rodovia) {
      const trechosData = [];

      for (const trecho of this.trechos) {
        if (trecho.rodovia == null || trecho.rodovia == undefined) {
          continue;
        }

        if (trecho.rodovia.descricao === rodovia) {
          if (this.trechoCidade != null) {
            if (this.trechoCidade == trecho.id) {
              trechosData.push(trecho);
            }
          } else {
            // cidade nao escolhida, carrega todos
            trechosData.push(trecho);
          }
        }
      }

      return trechosData;
    },
    getTrechoInfo(trecho) {
      if (trecho == null) {
        return null;
      }

      let trechoOutput = trecho.descricao;
      if (trecho.kmInicial != null && trecho.kmFinal != null) {
        trechoOutput +=
          ' - [KM ' +
          numeral(trecho.kmInicial).format('0.[00]') +
          ' ao KM ' +
          numeral(trecho.kmFinal).format('0.[00]') +
          ']';
      }

      return trechoOutput;
    },
    handleSelectCidade() {
      this.trechoCidade = null;
      for (const cid of this.cidades) {
        if (cid.id === this.cidade.id) {
          this.trechoCidade = cid.idTrecho;
          break;
        }
      }

      if (this.trechoCidade != null) {
        if (this.trecho == null || this.trecho !== this.trechoCidade) {
          this.trecho = this.trechoCidade;
        }
      }
    },
    hideModal() {
      this.$bvModal.hide('confirm-modal');
      this.$router.push('/');
    },
    hideModalError() {
      this.$bvModal.hide('error-modal');
    },
    onSubmit() {
      this.errorKmInicial = null;
      this.errorKmFinal = null;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        const datSolicitacao = new Date();

        // Form submit logic
        const sigla = this.$store.state.empresa.empresaAtual.sigla;
        const token = this.$store.state.account.user;
        const requestOpts = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        };

        const formData = new FormData();
        formData.append('datHorSolicitacao', moment(datSolicitacao).format('YYYY-MM-DD HH:mm:ss'));
        formData.append('titulo', this.titulo);

        if (this.tipo != undefined) formData.append('tipo', this.tipo.id);

        if (this.area != undefined) formData.append('area', this.area);

        if (this.objetivo != undefined) formData.append('objetivo', this.objetivo);

        if (this.trecho != undefined) formData.append('trecho', this.trecho);

        if (this.sentido != undefined) formData.append('sentido', this.sentido);

        if (this.cidade != undefined) formData.append('cidade', this.cidade.idCidade);

        if (this.kmInicial != undefined) formData.append('kmInicial', this.kmInicial);

        if (this.kmFinal != undefined) formData.append('kmFinal', this.kmFinal);

        if (this.local != undefined) formData.append('local', this.local);

        if (this.alca != undefined) formData.append('alca', this.alca);

        if (this.faixa != undefined) formData.append('faixa', this.faixa);

        if (this.observacao != undefined) formData.append('observacoes', this.observacao);

        for (var i = 0; i < this.files.length; i++) {
          formData.append('files', this.files[i]);
        }

        for (var x = 0; x < this.tiposAnexo.length; x++) {
          formData.append('tiposAnexo', this.tiposAnexo[x]);
        }

        // Seta o grupo como 'Demandas'
        formData.append('grupo', 1);

        Vue.axios
          .post(`/demandas/${sigla}`, formData, requestOpts)
          .then(response => {
            this.protocolo = response.data.nroProtocolo;

            if (this.protocolo == null || this.protocolo == undefined) {
              this.$bvModal.show('error-modal');
            } else {
              this.$bvModal.show('confirm-modal');

              this.$notify({
                group: 'msgs',
                title: 'Confirmação',
                text: 'Solicitação incluída com sucesso.'
              });
            }
          })
          .catch(error => {
            const errorMsg = error.response ? error.response.data.message : error;

            if (errorMsg.toLowerCase().indexOf('km inicial') != -1) {
              this.errorKmInicial = 'Trecho: Erro Km Inicial';
              this.errorKmFinal = 'Trecho: Erro Km Final';
            }

            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: errorMsg,
              type: 'error'
            });
          });
      });
    },
    onUpload(files) {
      this.tiposAnexo = [];
      for (var i = 0; i < files.length; i++) {
        this.tiposAnexo.push('PB');
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    getImagemBackgound() {
      this.backgroundTopoEmpresa = "background-image: url('img/" + this.empresaAtual.sigla + "/solicitacao.jpg')";
      // console.log(this.backgroundTopoEmpresa)
    }
  }
};
</script>
<style></style>
